import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=4f11353e&"
import script from "./Waiting.vue?vue&type=script&lang=ts&"
export * from "./Waiting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports